/**
 * Identifies this browser tab to the API (the `X-Client-Id` header). The API stamps it on
 * the realtime broadcast a save causes, so this tab can skip the echo of its own edit while
 * other tabs, other authors and MCP edits still come through.
 */
export const CLIENT_ID: string =
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
